import { NodeID } from '@builder/schemas';

import { useAppNodeElementByNodeID } from 'src/providers';

export const useNodeElementStyle = (nodeID?: NodeID): Record<string, unknown> | null => {
  const nodeElementDataRecords = useAppNodeElementByNodeID(nodeID || '');

  return nodeElementDataRecords?.styles;
};
